export const RemoveAccent = (newString) => {
  let string = newString;
  const mapAccentsHex = {
    a: /[\xE0-\xE6]/g,
    A: /[\xC0-\xC6]/g,
    e: /[\xE8-\xEB]/g,
    E: /[\xC8-\xCB]/g,
    i: /[\xEC-\xEF]/g,
    I: /[\xCC-\xCF]/g,
    o: /[\xF2-\xF6]/g,
    O: /[\xD2-\xD6]/g,
    u: /[\xF9-\xFC]/g,
    U: /[\xD9-\xDC]/g,
    c: /\xE7/g,
    C: /\xC7/g,
    n: /\xF1/g,
    N: /\xD1/g,
  };

  for (const letter in mapAccentsHex) {
    const RegularExpression = mapAccentsHex[letter];
    string = string.replace(RegularExpression, letter);
  }

  return string;
};

export const Capitalize = (text) => {
  if (typeof text !== 'string') return '';

  const string = text.toLowerCase();

  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const trimWhiteSpace = (text) => {
  const valueFormat = text?.trim();
  return valueFormat;
}
